import React, { useState, useEffect, useCallback } from 'react'; 
import TotalPostsCard from '../components/CardTotalPostagem';
import PostagemPorPeriodoDia from '../components/PostagemPorPeriodoDia';
import PostagemPorDiaSemana from '../components/PostagemPorDiaSemana';
import GraficoPostagemMesAno from '../components/GraficoPostagemMesAno';
import TotalCommentsCard from '../components/CardTotalComentario';
import AveragePostsPerMonthCard from '../components/MediaPostagemMes';
import AverageCommentsPerPostCard from '../components/MediaComentarioPostagem';
import '../styles/Home.css';
import '../styles/ChartStyles.css'; 
import '../styles/CardStyles.css'
import '../styles/FilterContent.css'; 
import { fetchTotalPostagens } from '../services/ApiService'; 

function Home() {
  const [dataInicioTotal, setDataInicioTotal] = useState('');
  const [dataFimTotal, setDataFimTotal] = useState('');

  const fetchPostData = useCallback(async () => {
    try {
      const { dataInicioTotal, dataFimTotal } = await fetchTotalPostagens();
      setDataInicioTotal(dataInicioTotal);
      setDataFimTotal(dataFimTotal);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  }, []);

  useEffect(() => {
    fetchPostData();
  }, [fetchPostData]);

  return (
    <div className="filter-container">
      <h1 className="page-title-analyses">Indicadores</h1>
      <p className="data-period">Os dados apresentados foram coletados entre <strong>{dataInicioTotal}</strong> e <strong>{dataFimTotal}</strong>.</p>
      <div className="cards-container">
        <TotalPostsCard />
        <TotalCommentsCard />
        <AveragePostsPerMonthCard/>
        <AverageCommentsPerPostCard/>
      </div>
      <div className="charts-container">
        <div className="chart-container">
          <PostagemPorPeriodoDia  />
        </div>
        <div className="chart-container">
          <PostagemPorDiaSemana/>
        </div>
        <div className="chart-container">
          <GraficoPostagemMesAno/>
        </div>
      </div>
    </div>
  );
}

export default Home;
